/* src/app/features/contratacao/limite-exposicao/listagem/limite-exposicao-listagem.component.scss */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
.negativo {
  color: red;
}
/*# sourceMappingURL=limite-exposicao-listagem.component.css.map */
